module.exports = __webpack_public_path__ + "img/LBC1.8fcaa9f8.png";